<template>
  <div class="main">
    <h2>Nuevo análisis de Portafolio</h2>
    <el-form :model="investmentData" status-icon :rules="formRules" ref="investmentData">
      <breadcrumbs class="breadcrumbs" section="2"></breadcrumbs>
      <h3 class="second-title">Agregar Emisoras</h3>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Mercado" prop="assetClass">
            <el-select v-model="investmentData.assetClass" @change="clearAssets">
              <el-option-group v-for="item in assetClasses" :key="item.id" :label="item.name" :value="item.id">
                <el-option v-for="assetClass in item.options" :key="assetClass.id" :label="assetClass.name" :value="assetClass.id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Emisora" prop="idAsset">
            <el-autocomplete :fetch-suggestions="fetchInvestments" :trigger-on-focus="false" placeholder="Buscar por nombre de emisora"
            v-model="investmentData.assetLabel" @select="handleInvestmentSelect">
            <template slot-scope="{ item }">
              <span class="link" :value="item.id">{{ item.name }}</span>
            </template>
            </el-autocomplete>
            <div v-if="showNoResultsError" class="input-message">Ninguna emisora coincide</div>
            <div v-if="showCreatingNE" class="input-message">Estarás creando una nota estructurada</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="usePercentageForm" label="Monto total del portafolio" prop="totalInvestment">
        <money v-model.lazy="totalInvestment" v-bind="currencyFormat" :class="{'disabled': currentInvestments.length > 0}" @input.native="getTotalAmount" :disabled="currentInvestments.length > 0"></money>
      </el-form-item>
      <el-form-item prop="totalSecurities">
        <el-col :span="12" :class="['customButtonA',{'selected': !usePercentageForm}]" style="margin-bottom:6px">
          <p v-on:click="togglePercentage()">No. de títulos</p>
        </el-col>
        <el-col :span="12" :class="['customButtonB',{'selected': usePercentageForm}]">
          <p v-on:click="togglePercentage()">%</p>
        </el-col>
        <money v-if="usePercentageForm" v-model.lazy="investmentData.totalSecurities" v-bind="percentageFormat" @input.native="getTotalAmount"></money>
        <money v-else v-model.lazy="investmentData.totalSecurities" v-bind="securitiesFormat" @input.native="getTotalAmount"></money>
      </el-form-item>
      <el-form-item label="Precio" prop="price_of_note">
        <money v-model.lazy="investmentData.price_of_note" v-bind="currencyFormat" :class="{'disabled' : !this.isNEAssetClass || NEExists}" :disabled="!this.isNEAssetClass || NEExists" @change="getTotalAmountAndSecurities"></money>
      </el-form-item>
      <el-form-item label="Monto Invertido" prop="totalAmount">
        <money v-model.lazy="investmentData.totalAmount" :disabled="usePercentageForm" :class="{'disabled':usePercentageForm}"></money>
        <!-- <el-input placeholder="" prefix-icon="el-icon-edit" v-model.trim="investmentData.totalAmount" @change="getSecurities" :disabled="usePercentageForm"></el-input> -->
      </el-form-item>
      <el-col :span="10" :offset="14">
        <div class="blue-button" v-on:click="validateAsset('investmentData')">
        <p>Agregar</p>
        </div>
        <div v-if="showDuplicateAssetError" class="error-message">Esta emisora ya ha sido agregada</div>
      </el-col>
    </el-form>
    <div v-if="currentInvestments.length > 0">
      <el-row :gutter="20">
        <el-col :span="24">
          <p class="subtitle">Emisoras</p>
        </el-col>
      </el-row>
      <el-table :data="currentInvestments" >
        <el-table-column prop="assetClassLabel" label="Mercado" width="130">
        </el-table-column>
        <el-table-column prop="assetLabel" label="Emisora" width="130">
        </el-table-column>
        <el-table-column prop="totalSecurities" :label="usePercentageForm ? 'Porcentaje': 'Numero de titulos'" width="130">
          <template slot-scope="scope">
            <p> {{ formatSecurities(scope.row.totalSecurities) }} </p>
          </template>
        </el-table-column>
        <el-table-column prop="price_of_note" label="Precio de la nota" width="130">
          <template slot-scope="scope">
            <p> {{ formatPrice(scope.row.price_of_note) }} </p>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="Monto invertido" width="130">
          <template slot-scope="scope">
            <p> {{ formatPrice(scope.row.totalAmount) }} </p>
          </template>
        </el-table-column>
        <el-table-column prop="index" width="30">
          <template slot-scope="scope">
            <i class="el-icon-circle-close-outline" v-on:click="_deleteAsset(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPercentageError" class="error-message">Es necesario que los montos agregados sumen el 100% del portafolio</div>
    <div class="bottom-section">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="container-back-button">
            <router-link to="/registro-datos-generales">
              <i class="el-icon-arrow-left blue-arrow-icon"></i>
              <p class="back-button">Atrás</p>
            </router-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="margin-left: auto; margin-right: 0px; display: block; width: 142px;" v-on:click="goToConfirmation()">
            <p class="continue-button" >Continuar</p>
            <i class="el-icon-arrow-right blue-arrow-icon"></i>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import breadcrumbs from './Breadcrumbs';
import { getAssetClasses, getAssets, addAsset } from '@/graphql'

export default {
  components: {
    breadcrumbs
  },
  data() {
    return {
      currencyFormat: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      securitiesFormat: {
        thousands: ',',
        precision: 0,
        masked: false
      },
      percentageFormat: {
        thousands: ',',
        suffix: '%',
        precision: 0,
        masked: false
      },
      filteredAssets: [],
      NEExists: true,
      isLoading: false,
      assetClasses: [{
        label: '',
        options: []
      },{
        label: '',
        options: [{
          id: 'defaultAll',
          name: 'Todos los mercados'
        }]
      }],
      assets: [],
      formRules: {
        totalAmount: [
          { required: true, message: 'Debes ingresar un monto', trigger: 'focus'},
          { validator: this.validateAmount,
            trigger: ["blur"]
          }
        ],
      },
      totalInvestment: '',
      showPercentageError: false,
      showDuplicateAssetError: false,
      showNoResultsError: false,
      showCreatingNE: false,
      investmentData: {
        assetClass: 'defaultAll',
        assetClassLabel: '',
        idAsset: '',
        assetLabel: '',
        totalSecurities:'',
        price_of_note:'',
        totalAmount:''
      }
    }
  },
  mounted () {
    this.$apollo.query({ query: getAssetClasses,fetchPolicy: 'cache-first'})
      .then((data) => {this.assetClasses[0].options = data.data.allAssetClasses})
    this.totalInvestment = this.$store.getters.getTotalInvestmentAmount || ''
  },
  watch: {
    assets: function (value) {
      // Reset select values when getting new list of assets
      this.filteredAssets = value
    },
    totalPortfolioInvestment: function (value) {
      this.totalInvestment = value
    }
  },
  computed: {
    currentInvestments: function () {
      return this.$store.getters.getTransmitersData
    },
    currentCuttoffDate: function () {
      return this.$store.getters.getGeneralData.cutoff_date
    },
    isNEAssetClass: function () {
      return this.investmentData.assetClass === '6'
    },
    usePercentageForm: function () {
      return this.$store.getters.getFormValueTypes
    }
  },
  methods: {
    fetchInvestments(query, callback) {
      this.showNoResultsError = false
      this.$apollo.query({
        query: getAssets,
        variables: {
          cuttofDate: this.currentCuttoffDate,
          startsWith: query,
          idAssetClass: this.investmentData.assetClass !== 'defaultAll' ? this.investmentData.assetClass : undefined
        },
        fetchPolicy: 'network-only'
      }) .then((data) => {
        const results = data.data.allAssets
        if (results.length !== 0) {
          this.assets = data.data.allAssets
        } else if (results.length === 0 && this.isNEAssetClass) {
          this.NEExists = false
          this.showCreatingNE = true
        } else {
          this.showNoResultsError = true
        }
        callback(results)
      })
    },
    handleInvestmentSelect (investment) {
      this.investmentData.idAsset = investment.id
      this.investmentData.assetLabel = investment.name
      this.investmentData.assetClassLabel = investment.assetClass.name
      this.investmentData.price_of_note = investment.price
      if (this.investmentData.totalSecurities) {this.getTotalAmount()}
    },
    goToConfirmation () {
      if (this.usePercentageForm) {
        this.showPercentageError = true
        this.validatePercentageForm(this.currentInvestments)
      } else {
        this.$router.push('/registro-confirmacion')
      }
    },
    validatePercentageForm (investments) {
      let totalPercentage = 0
      for (const index in investments) {
        totalPercentage += investments[index].totalSecurities
      }
      if (totalPercentage === 100) {
        this.$router.push('/registro-confirmacion')
      } else  {
        this.showPercentageError = true
      }
    },
    togglePercentage () {
      if (this.currentInvestments.length === 0) {
        this.$store.dispatch('setPercentageBasedForm', !this.usePercentageForm)
        this.investmentData.totalSecurities = ''
        this.investmentData.totalAmount = ''
      }
    },
    validateAmount (rule, value, callback) {
      const amount = parseFloat(value)
      if (amount <= 0) {
        callback(new Error("El monto debe ser mayor a 0"));
      } else if (amount > 0) {
        callback();
      }
    },
    clearAssets(id) {
      this.assets = []
      this.showNoResultsError = false
      this.showCreatingNE = false
      // Clear if there was any asset already selected
      this.investmentData.idAsset = ''
      this.investmentData.assetLabel = ''
      this.investmentData.totalSecurities = ''
      this.investmentData.price_of_note = ''
      this.investmentData.totalAmount = ''
      this.$refs['investmentData'].clearValidate()
    },
    getAssetInfo(id) {
      const asset = this.assets.filter(asset => asset.id === id)
      this.NEExists = asset.length === 1
      if (!this.isNEAssetClass || this.NEExists) {
        this.investmentData.assetLabel = asset[0].name
        this.investmentData.assetClassLabel = asset[0].assetClass.name
        this.investmentData.price_of_note = asset[0].price
        if (this.investmentData.totalSecurities) {this.getTotalAmount()}
      }
    },
    parseValues(data) {
      const idAsset = data.idAsset !== '' ? parseInt(data.idAsset) : 0
      const totalSecurities = data.totalSecurities !== '' ? parseFloat(data.totalSecurities) : 0
      const totalAmount = data.totalAmount !== '' ? parseFloat(data.totalAmount) : 0
      return {
        assetClass: data.assetClass,
        assetClassLabel: data.assetClassLabel,
        idAsset,
        assetLabel: data.assetLabel,
        totalSecurities,
        price_of_note: data.price_of_note,
        totalAmount
      }
    },
    validateAsset(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          const isDuplicateAsset = this.validateNoDuplicateInvestment(this.investmentData.idAsset)
          if (isDuplicateAsset) {
            this.showDuplicateAssetError = true
          } else {
             const parsedValues = this.parseValues(this.investmentData)
            this.addAssetToList(parsedValues)
          }
        } else {
          return false
        }
      })
    },
    validateNoDuplicateInvestment (id) {
      const result = this.currentInvestments.filter(investment => investment.idAsset  == id)
      const isDuplicateAsset = result.length > 0
      return isDuplicateAsset
    },
    addAssetToList(data) {
      this.$store.dispatch('setTotalInvestment', this.totalInvestment)
      if (!this.isNEAssetClass || this.NEExists) {
        this.$store.dispatch( 'saveInvestment', data).then(this.$refs['investmentData'].resetFields())
      }  else {
        // If its a non registred NE asset it will be created
        this.createAsset()
      }
    },
    // Use to create - Notas Estructuradas investments
    createAsset () {
      this.$apollo.mutate({
        mutation: addAsset,
        variables: {
          name: this.investmentData.assetLabel,
          assetClassId: 6,
          price: parseFloat(this.investmentData.price_of_note),
          period: this.currentCuttoffDate
        },
      }).then((data) => this.createAssetSuccess(data.data.createAsset.asset)
      ).catch((error) => {
        this.$message({
          type: 'error',
          message: 'Ocurrió un error, intenta más tarde'
        })
      })
    },
    createAssetSuccess (data) {
      const investment = {
        assetClass: data.assetClass.id,
        assetClassLabel: data.assetClass.name,
        idAsset: parseInt(data.id),
        assetLabel: data.name,
        totalSecurities: parseFloat(this.investmentData.totalSecurities),
        price_of_note: data.price,
        totalAmount: parseFloat(this.investmentData.totalAmount)
      }
      this.$store.dispatch( 'saveInvestment', investment).then(this.$refs['investmentData'].resetFields())
    },
    _deleteAsset(assetIndex){
      this.$confirm('Desea eliminar esta emisora. Continuar?', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch( 'deleteInvestment', assetIndex)
        this.$message({
          type: 'success',
          message: 'Emisora eliminada'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Eliminación cancelada'
        });
      });
    },
    // We use this method to call a getter that will get the data from a state
    getPreviousData () {
      return this.$store.getters.getTransmitersData
    },
    getTotalAmount() {
      const amount = parseInt(this.investmentData.totalSecurities)
      // Percentage based investment registry
      if (this.usePercentageForm && amount) {
        const total = this.totalInvestment
        const percentage = amount/100
        this.investmentData.totalAmount = (percentage*total)/1
      // Total securities based investment registry
      } else {
        if (this.investmentData.price_of_note && this.investmentData.totalSecurities) {
          this.investmentData.totalAmount = this.investmentData.price_of_note*amount
        } else {
          this.investmentData.totalAmount = ''
        }
      }
    },
    getSecurities () {
      const amount = parseFloat(this.investmentData.totalAmount)
      // Percentage based investment registry
      if (this.usePercentageForm) {
      console.log('por %')
      // Total securities based investment registry
      } else {
        if (this.investmentData.price_of_note && this.investmentData.totalAmount) {
          this.investmentData.totalSecurities = amount/this.investmentData.price_of_note
        } else {
          this.investmentData.totalSecurities = ''
        }
      }
    },
    getTotalAmountAndSecurities () {
      const price = parseFloat(this.investmentData.price_of_note)
      // Total securities based investment registry
      if (!this.usePercentageForm) {
        if (this.investmentData.totalSecurities) {
          this.investmentData.totalAmount = price*this.investmentData.totalSecurities
        } else if (this.investmentData.totalAmount) {
          this.investmentData.totalSecurities = this.investmentData.totalAmount/price
        }
      }
    },
    formatPrice (price) {
      return  price % 1 !== 0 ? `$${price.toFixed(2).toLocaleString()}` : `$${price.toLocaleString()}`
    },
    formatSecurities(amount) {
      if (this.usePercentageForm) {
        return amount % 1 !== 0 ? `${amount.toFixed(2)}%` : `${amount}%`
      } else {
        return  amount % 1 !== 0 ? amount.toFixed(2).toLocaleString() : amount.toLocaleString()
      }
    }
  },
}
</script>
<style scoped lang="css">

.v-money {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding: 0 15px;
}

.v-money.disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

.el-form {
  display: flex;
  flex-direction: column;
}

.el-form-item {
  margin-bottom: 40px;
}

/* Select element */

.el-select,
.el-autocomplete {
  width: 100%;
}

a {
  text-decoration: none;
}

p {
  margin: 0px;
}

hr {
  border-color: #4366DE;
  margin: 0px;
  margin-bottom: 2px;
}

h2 {
  margin: 0;
}

h3 {
  font-weight: 400;
  position: relative;
  left: 4px;
}

.second-title {
  text-align: center;
  margin-bottom: 3em;
  font-size: 22px;
  font-weight: 600;
}

.subtitle {
  font-size: 22px;
  margin-bottom: 8px;
  margin-top: 18px;
}

.text-question {
  text-decoration: underline;
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: block;
  width: 126px;
}

.blue-button {
  background-color: #4366DE;
  color: white;
  text-align: center;
  height: 38px !important;
  cursor: pointer;
  border-radius: 3px;
  margin-top: 16px;
}

.blue-button p {
  padding: 10px;
}

.label {
  margin-top: 16px;
}

.main {
  display: block;
  margin: auto;
  width: 100%;
  max-width: 720px;
  margin-top: 2rem;
  padding: 1rem;
  box-sizing: border-box !important;
}

.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  height: 28px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-input__inner {
  height: 38px;
}

/* Styles for the toogle buttons */

.customButtonA {
  height: 32px;
  background-color: #F1F1F1;
  font-size: 1rem;
  box-sizing: border-box;
  text-align: center;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  cursor: pointer;
}

.customButtonA p, .customButtonB p {
  font-size:1.17em;
  font-weight:400;
  display: flex;
  justify-content: center;
}


.customButtonB {
  height: 32px;
  background-color: #F1F1F1;
  font-size: 1rem;
  box-sizing: border-box;
  text-align: center;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  cursor: pointer;
}

.selected{
  background-color: #4B4B4B;
  color: white;
}

/* Style for the table */

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-table {
  font-size: 12px;
  text-align: left;
}

/* Style for the cross icon */

.el-icon-circle-close-outline {
  float: right;
  font-size: 20px;
  cursor: pointer;
}

/* Style for breadcrumbs component */

.breadcrumbs {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

/* Style for date component */

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.container-continue-button {
  display: block;
  width: 142px;
  margin-left: auto;
  margin-right: 0px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.continue-button {
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: inline-block;
  width: 115px;
  font-weight: 500;
  font-size: 22px;
  color: #4366DE;
}

/* Style for bottom section */

.bottom-section {
  margin-top: 3em;
  margin-bottom: 3em;
}

.blue-extended-button {
  background-color: #4366DE;
  color: white;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  display: inline-block;
  padding: 10px 0;
  position: relative;
  width: 100%;
  bottom: 3px;
}

.container-back-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 6px;
}

.back-button {
  display: inline-block;
  font-weight: 500;
  font-size: 22px;
  color: #4366DE;
  margin-left: 24px;
}

.blue-arrow-icon {
  font-size: 22px;
  font-weight: 600;
  color: #4366DE;
  position: relative;
  top: 2px;
}

/* Table of  transmitters */

.list-container {
  padding: 0;
}

.error-message {
  color: #f56c6c;
  font-size: 14px;
  margin: 20px 0;
}

.input-message {
  color: #4366DE;
  font-size: 14px;
  height: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/RegisterTransmiters.vue